import { SxProps, YodaColors } from 'yoda-ui/yodaTheme';

export const Collapse: SxProps = {
  width: '100%',
};

export const collapseContentStyles: SxProps = {
  borderTop: `1px solid ${YodaColors.gray2}`,
};
